import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface MaintenanceConfig {
  is_enabled:                   boolean;
  start_utc:                    string | null;
  end_utc:                      string | null;
  pre_message:                  string | null;
  active_message:               string | null;
  completion_message:           string | null;
  days_before_show:             number;
  auto_close_minutes:           number;
  auto_completion_message_time: number;
}

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  constructor(private http: HttpClient) {}

  getConfig(): Observable<MaintenanceConfig | null> {
    return this.http
      .get<MaintenanceConfig>(`assets/json/maintenance.json?_=${Date.now()}`)
      .pipe(catchError(() => of(null)));
  }
}
